<template>
  <form>
    <div class="loader" v-show="locked">
      <!-- Ugly svg-code from bcklnd -->
      <svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
        <g fill="none" fill-rule="evenodd" stroke-width="2">
          <circle cx="50" cy="50" r="1">
            <animate attributeName="r"
                     begin="0s" dur="1.8s"
                     values="1; 50"
                     calcMode="spline"
                     keyTimes="0; 1"
                     keySplines="0.165, 0.84, 0.44, 1"
                     repeatCount="indefinite"/>
            <animate attributeName="stroke-opacity"
                     begin="0s" dur="1.8s"
                     values="1; 0"
                     calcMode="spline"
                     keyTimes="0; 1"
                     keySplines="0.3, 0.61, 0.355, 1"
                     repeatCount="indefinite"/>
          </circle>
          <circle cx="50" cy="50" r="1">
            <animate attributeName="r"
                     begin="-0.9s" dur="1.8s"
                     values="1; 50"
                     calcMode="spline"
                     keyTimes="0; 1"
                     keySplines="0.165, 0.84, 0.44, 1"
                     repeatCount="indefinite"/>
            <animate attributeName="stroke-opacity"
                     begin="-0.9s" dur="1.8s"
                     values="1; 0"
                     calcMode="spline"
                     keyTimes="0; 1"
                     keySplines="0.3, 0.61, 0.355, 1"
                     repeatCount="indefinite"/>
          </circle>
        </g>
      </svg>
    </div>
    <!-- Toolbar -->
    <div class="mb-2">
      <div v-if="rollback && typeof rollback === 'string'" class="mb-2 text-readable text-muted small">{{ rollback }}</div>
      <div v-else class="d-flex justify-content-between">
        <div>
          <b-dropdown size="sm" class="small text-readable" variant="outline-secondary" :disabled="locked || !(Array.isArray(rollback) && rollback.length > 0)">
            <template #button-content>
              <span class="px-1">Rollback</span>
            </template>
            <b-dropdown-item :key="point" v-for="point of rollback" style="text-transform: capitalize" @click="requestRollback(point)">
              Revert to <i><b>{{ point }}</b> State</i>
            </b-dropdown-item>
          </b-dropdown>
          <template v-if="invoice.quick_pay === 2 || invoice.quick_pay === 0" >
            <b-btn @click.prevent="handleQuickPay(1)" size="sm" class="ml-1 small text-readable" variant="outline-secondary">
              Undo Quick Pay {{ invoice.quick_pay === 2 ? 'Confirmation' : 'Rejection' }}
            </b-btn>
            <span v-if="invoice.quick_pay === 2" class="quick-pay-notify text-readable ml-2">
              Quick Pay Approved
            </span>
          </template>
        </div>
        <b-btn @click.prevent="deleteInvoice()" size="sm" class="ml-1 small text-readable" variant="outline-danger">
          Delete Invoice
        </b-btn>
      </div>
    </div>
    <!-- Alerts -->
    <div v-if="invoice.quick_pay === 1" class="card w-auto border border-warning text-center" style="max-width: 30rem;">
      <div class="card-body">
        <h5 class="text-readable text-warning mb-3">
          User has requested Quick Pay.
        </h5>
        <div class="text-readable mb-3">
          By confirming, a <strong>{{ parseFloat(invoice.quick_pay_fee).toFixed(2) }} %</strong> fee will be applied to the wallet transaction when the invoice is marked as paid.<br/>
        </div>
        <div class="d-flex justify-content-center flex-wrap" style="gap: 15px">
          <button :disabled="locked" class="btn btn-outline-primary text-readable" @click.prevent="handleQuickPay(2)">Confirm Quick Pay</button>
          <button :disabled="locked" class="btn btn-outline-danger text-readable" @click.prevent="handleQuickPay(0)">Decline Quick Pay</button>
        </div>
      </div>
    </div>
    <!-- State Handler -->
    <div class="card">
      <component :is="currentStateVue" @action="action" :invoice="invoice"></component>
    </div>
  </form>
</template>

<script>
import TForm from '../TForm';
import axios from 'axios';

export default {
  name: 'InvoiceStateHandler',
  props: {
    invoice: Object,
    rollback: {
      default: [],
    },
  },
  data() {
    return {
      locked: false,
      issues: [],
    };
  },
  computed: {
    currentStateVue() {
      const state = this.currentState;
      if (['Draft', 'Rejected'].includes(state)) {
        return 'Waiting';
      }

      return state;
    },
    currentState() {
      return this.invoice.state.split('\\').pop();
    },
  },
  mounted() {
    this.emitInvoiceUpdate();
    this.$eventHub.$on('get-update', data => {
      if (data === 'invoice') {
        this.emitInvoiceUpdate();
      }
    });
  },
  methods: {
    handleQuickPay(state) {
      if (this.locked) {
        return;
      }
      this.lock();
      axios.patch(`/invoices/handler/${this.invoice.id}/quickPay`, {
        state: state,
      }).then(response => {
        let invoice = {...this.invoice};
        invoice.quick_pay = response.data.state;
        this.invoice = invoice;
        this.refresh();
      }).catch((error) => {
        Swal.fire({
          icon: 'error',
          text: error.response.data.message,
        });
      }).finally(() => {
        this.unlock();
      });
    },
    deleteInvoice() {
      Swal.fire({
        title: 'Delete this invoice?',
        html: `<strong>You will not be able to revert this action</strong>, it is better to rollback to the pending state and reject the invoice if it is an issue that can be resolved by the client.`,
        icon: 'warning',
        input: "textarea",
        inputPlaceholder: "Reason for deletion",
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#323436',
        confirmButtonText: 'Delete Invoice',
      }).then((result) => {
        console.log(result.value);
        if (result.isConfirmed) {
          if (this.locked) {
            return;
          }
          this.lock();
          axios.patch(`/invoices/handler/${this.invoice.id}/delete`, {
            message: result.value || '',
          }).then(response => {
            Swal.fire({
              icon: 'success',
              text: response.data.message,
            }).finally(() => {
              window.location.href = '/invoices';
            });
          }).catch((error) => {
            Swal.fire({
              icon: 'error',
              text: error.response.data.message,
            });
          }).finally(() => {
            this.unlock();
          });
        }
      });
    },
    requestRollback(point) {
      Swal.fire({
        title: 'Are you sure?',
        html: `This will remove all data after the "${point}" state.<br>You will not be able to revert this action.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#c42491',
        cancelButtonColor: '#323436',
        confirmButtonText: 'Commit Rollback',
      }).then((result) => {
        if (result.isConfirmed) {
          if (this.locked) {
            return;
          }
          this.lock();
          axios.patch(`/invoices/handler/${this.invoice.id}/rollback/${point}`).then(response => {
            this.refresh(response);
            Swal.fire({
              icon: 'success',
              text: response.data.message,
            });
          }).catch((error) => {
            Swal.fire({
              icon: 'error',
              text: error.response.data.message,
            });
          }).finally(() => {
            this.unlock();
          });
        }
      });
    },
    emitInvoiceUpdate() {
      this.$eventHub.$emit('invoice-update', this.invoice);
    },
    action(data) {
      this.update(data);
    },
    lock() {
      this.locked = true;
    },
    unlock() {
      this.locked = false;
    },
    refresh(response) {
      const data = response.data || {};
      if (data.hasOwnProperty('invoice')) {
        this.invoice = data.invoice;
      }
      if (data.hasOwnProperty('rollbackPoints')) {
        this.rollback = data.rollbackPoints;
      }
      this.emitInvoiceUpdate();
    },
    update(data) {
      if (this.locked) {
        return;
      }
      this.lock();

      axios.patch(`/invoices/handler/${this.invoice.id}`, data).then(response => {
        this.refresh(response);
        let message = response.message || response.data.message || null;
        if (!!message) {
          this.$toasted.success(message);
        }
      }).catch((error) => {
        /**
         * error.response
         * - data
         *    - errors
         *        -transition
         *    - message
         */
        this.$toasted.error(error.response.data.message);
      }).finally(() => {
        this.unlock();
      });
    },
  },
};
</script>

<style scoped>

.quick-pay-notify {
  display: inline-block;
  border: 1px dashed;
  padding: 0.2rem 0.5rem;
  border-radius: 3px;
  font-size: small;
  color: #ff8d00 !important;
}

form {
  position: relative;
}

.loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(38, 43, 66, 0.9);
  z-index: 1;
  display: flex;
  align-items: center;
}

.loader svg {
  width: 50px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

</style>
